import { connect } from 'react-redux';
import PiutangSiswa from '../../../../views/Finance/Spp/LaporanSPP/PiutangSiswa.view';
import {
  listBlockStudents, saveBlockStudents, updateBlockStudents, reportTotalPayments, listStudentsSpp, listStudentsSppGeneral, reportPaymentsNonRutinNew, listStudentsUpp, listStudentsUppGeneral, studentCardGeneral,
} from '../../../../states/thunks/academics.thunk';
import {
  getStudentSPPOptions, getPrmStudentBlockGeneral, getMsTempsSiswaOptions, getSchoolUnitsOptions, getPrmStudentGeneral, getPrmPaymentsNonGeneral, getPrmPaymentsNon, getPeriodsOptions,
} from '../../../../states/thunks/options.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getStudentSPPOptions: payload => dispatch(getStudentSPPOptions(payload)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
    handleListBlockStudents: (payload, goback) => dispatch(listBlockStudents(payload, goback)),
    handleSaveBlockStudent: (payload, goback) => dispatch(saveBlockStudents(payload, goback)),
    handleUpdateBlockStudent: (payload, goback) => dispatch(updateBlockStudents(payload, goback)),
    getPrmStudentGeneralOptions: payload => dispatch(getPrmStudentGeneral(payload)),
    getPrmStudentBlockGeneralOptions: payload => dispatch(getPrmStudentBlockGeneral(payload)),
  };

}

export default connect(mapStateToProps, mapDispatchToProps)(PiutangSiswa);
